// src/features/auth/authSlice.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import logger from '../../../common/utils/logger';
import {
  getOfferBannersApi,
  getOffersCategoriesApi,
  getOffersHomeApi,
  getOffersListApi,
  getOffersSearchApi,
  getOffersOneApi,
  // postOffersRemoveFavoritesApi,
  // postOffersSaveFavoritesApi,
  saveOfferApi,
  unSaveOfferApi,
} from '../http';
import {
  getSavedFavoritesFromStorage,
  clearFavoritesFromStorage,
} from '../../../common/utils/localStorageFavorites';

export const getOffersHomeThunk = createAsyncThunk(
  'offers/home',
  async (_, { rejectWithValue }) => {
    try {
      return await getOffersHomeApi();
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

// export const getOffersHomeThunk = createAsyncThunk(
//   'offers/home',
//   async (_, { dispatch, getState }) => {
//     const { result, error } = get(getState(), ['offers', 'home']);

//     if (result || error) return;
//     return await dispatch(forceGetOffersHomeThunk({}));
//   },
// );

export const getOffersListThunk = createAsyncThunk(
  'offers/list',
  async (body, { rejectWithValue }) => {
    try {
      return await getOffersListApi(body);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getOffersSearchThunk = createAsyncThunk(
  'offers/search',
  async (body, { rejectWithValue }) => {
    try {
      return await getOffersSearchApi(body);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getOffersOneThunk = createAsyncThunk(
  'offers/one',
  async (body, { rejectWithValue }) => {
    try {
      return await getOffersOneApi(body);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const getOffersCategoriesThunk = createAsyncThunk(
  'offers/categories',
  async (body, { rejectWithValue }) => {
    try {
      return await getOffersCategoriesApi(body);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
// export const postOffersSaveFavoritesThunk = createAsyncThunk(
//   'offers/saveFavorites',
//   async (body, { rejectWithValue }) => {
//     try {
//       return await saveOfferApi(body);
//     } catch (error) {
//       return rejectWithValue(error.response.data);
//     }
//   },
// );
// export const postOffersRemoveFavoritesThunk = createAsyncThunk(
//   'offers/removeFavorites',
//   async (body, { rejectWithValue }) => {
//     try {
//       return await unSaveOfferApi(body);
//     } catch (error) {
//       return rejectWithValue(error.response.data);
//     }
//   },
// );

export const getOffersBannerThunk = createAsyncThunk(
  'offers/banners',
  async (body, { rejectWithValue }) => {
    try {
      return await getOfferBannersApi(body);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const saveOfferThunk = createAsyncThunk(
  'offers/save',
  async (offerId, { rejectWithValue }) => {
    try {
      return await saveOfferApi(offerId);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const unSaveOfferThunk = createAsyncThunk(
  'offers/unsave',
  async (offerId, { rejectWithValue }) => {
    try {
      return await unSaveOfferApi(offerId);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const migrateLocalFavoritesToApiThunk = createAsyncThunk(
  'offers/migrateLocalFavorites',
  async (_, { dispatch }) => {
    try {
      const localFavorites = getSavedFavoritesFromStorage();

      if (localFavorites.length > 0) {
        // Save all local favorites to API
        await Promise.all(
          localFavorites.map((offerId) => dispatch(saveOfferThunk(offerId)).unwrap()),
        );

        // Clear local storage after successful migration
        clearFavoritesFromStorage();
      }

      return true;
    } catch (error) {
      logger.error('Error migrating local favorites:', error);
      return false;
    }
  },
);
